export default __webpack_public_path__ + "static/media/calendar.615c0a93.png";